import { doRequest } from '@r1-frontend/do-request';
import { equipment as equipmentByCategories } from '@r1-frontend/api-domru/full-buy/v1/equipment';
import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import getProviderId from '@r1-frontend/shared/helpers/getProviderId';
import { EShopCategory } from '@r1-frontend/shared/types/EShopCategory';

import { speedBonusConnectionAnalytics } from '~/src/entities/speed-bonus/analytics';
import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { setRouters, toggleIsLoading, toggleIsShowConnection } from '~/src/entities/speed-bonus/context/actions';
import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';
import { activate, fetchConnectPrice } from '~/src/entities/speed-bonus/context/actions/thunk';
import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

const prepareRouter = (equipment: IEquipment): IPreparedRouter => {
    const sortedPrices = [...equipment.pricesV2].sort((a, b) => a.sort - b.sort);
    const [firstPrice] = sortedPrices;

    return ({
        id: equipment.globalId,
        category: equipment.category?.name || '',
        categoryTitle: equipment.category?.title || '',
        title: equipment.title,
        description: equipment.bodyFull || '',
        body: equipment.body,
        props: equipment.props,
        labels: equipment.labels.map(label => ({
            id: label.id,
            name: label.name,
            title: label.title,
            color: label.color || '',
            color_text: label.colorText || '',
        })),

        image: equipment.image || '',
        images: equipment.images,

        prices: sortedPrices.map(price => ({
            duration: price.duration || 0,
            cost: price.value || 0,
        })),
        selectedPrice: {
            duration: firstPrice?.duration || 0,
            cost: firstPrice?.value || 0,
        },

        quantity: 0,
    });
};

export const fetchRouters = () => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const providerId = Number(getProviderId());

    const { tariff, businessLogic } = getState();

    if (!tariff) {
        return;
    }

    speedBonusConnectionAnalytics.startConnection();

    const showConnectionHandler = () => {
        dispatch(fetchConnectPrice());

        businessLogic?.beforeSwitchToConnection && businessLogic.beforeSwitchToConnection();

        dispatch(toggleIsShowConnection(true));
    };

    const errorHandler = () => {
        if (tariff.speedBonusStatus === Plus100Status) {
            showConnectionHandler();

            speedBonusConnectionAnalytics.openConnectionConfirmation();
        } else {
            dispatch(activate());
        }
    };

    if (!tariff.speed) {
        errorHandler();
        return;
    }

    dispatch(toggleIsLoading(true));

    const response = await doRequest.fullBuy<IEquipment[]>(equipmentByCategories({
        providerId,
        categories: [EShopCategory.Routers],
        routerFilter: {
            minimumSpeed: tariff.speed,
            isBetterThanCurrentUserEquipment: 1,
        },
    }));

    if (response.isSuccess && response.payload.length) {
        const routers = response.payload.map(prepareRouter);

        dispatch(setRouters(routers));

        showConnectionHandler();

        speedBonusConnectionAnalytics.openRouterSelection();
    } else {
        errorHandler();
    }

    dispatch(toggleIsLoading(false));
};
